import { combineReducers } from 'redux'

import userSessionReducer from './user-session'
import notificationsReducer from './notifications'
import dashboardReducer from './dashboard'
import libraryReducer from './library'
import riderReducer from './rider'
import eventReducer from './event'
import stageElementsReducer from './stage-elements'
import alertsReducer from './alerts'
import modalReducer from './modal'
import commentsReducer from './comments'

const rootReducer = combineReducers({
  userSession: userSessionReducer,
  notifications: notificationsReducer,
  dashboard: dashboardReducer,
  library: libraryReducer,
  rider: riderReducer,
  event: eventReducer,
  stageElements: stageElementsReducer,
  alerts: alertsReducer,
  modal: modalReducer,
  comments: commentsReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js